import React, { FunctionComponent, useState } from 'react';
import classnames from 'classnames';

import { Attachment } from '@api/v4/attachments/attachmentTypes';
import { Asset, AssetTypes } from '@api/v4/assets/assetTypes';

interface PreviewImageProps {
  assetType: AssetTypes;
  isPreviewRenderError: boolean;
  resource: Attachment | Asset;
  setIsPreviewRenderError: SetStateDispatch<boolean>;
}

const extensionCopyMap = {
  [AssetTypes.People]: 'person',
  [AssetTypes.Press]: 'press',
  [AssetTypes.GenericFile]: 'empty',
};

const isAttachment = (resource: Attachment | Asset): resource is Attachment => !!(resource as Attachment).preview_type;

export const ImagePreview: FunctionComponent<PreviewImageProps> = ({
  assetType,
  resource,
  isPreviewRenderError,
  setIsPreviewRenderError,
}) => {
  let { extension } = resource;
  let srcUrl = '';
  let altCopy = '';
  const isMobile = BFG.currentUser.device === 'mobile-view';

  if (isAttachment(resource)) {
    altCopy = `${resource.filename}`;
    srcUrl = resource.view_thumbnail_retina.trim() || resource.thumbnail_url.trim();
    // use smaller image for mobile (assume lower bandwidth)
    srcUrl = isMobile ? resource.thumbnail_url.trim() : srcUrl;
  } else {
    // Resource is an asset with no attachments
    altCopy = bfTranslate('No image available');
    extension = extensionCopyMap[assetType];
  }

  const fallbackUrl = `//static-fast.brandfolder.com/assets/types/${extension}.svg`;
  const showFallbackUrl = isPreviewRenderError || !isAttachment(resource);

  return (
    <img
      alt={altCopy}
      className={classnames(
        'image-preview',
        { 'image-preview-error': isPreviewRenderError }
      )}
      data-private
      data-testid="asset-preview--image"
      onError={(): void => setIsPreviewRenderError(true)}
      src={showFallbackUrl ? fallbackUrl : srcUrl}
    />
  );
};
